'use client';

export { default } from './GlobalStyles';


//////////////////
// WEBPACK FOOTER
// ../@mui/styled-engine/GlobalStyles/index.js
// module id = 1567
// module chunks = 22